goog.provide("shadow.js.shim.module$src$svg$organisations$other$meta_svg$default");
shadow.js.shim.module$src$svg$organisations$other$meta_svg$default = shadow.js.shim.module$src$svg$organisations$other$meta_svg.default;
